import * as React from 'react'
import Select from 'react-select'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { ICategoryContract } from '@getgreenline/homi-shared'
import { Track } from '../../../../Track'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  category: ICategoryContract
  onClose: () => void
}

interface State {
  newCategoryId?: string
  isSaving: boolean
}

@inject('currentCompanyStore')
@observer
export class DeleteCategoryModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isSaving: false,
    }
  }

  deleteCategory() {
    if (
      this.state.newCategoryId ||
      window.confirm("Are you sure you don't want to migrate categories?")
    ) {
      this.setState({ isSaving: true })
      this.props
        .currentCompanyStore!.productStore!.deleteCategory(
          this.props.category.id,
          this.state.newCategoryId,
        )
        .then(() => {
          if (this.state.newCategoryId) {
            Track.track('dashboard:categories_merged', {
              originalId: this.props.category.id,
              newId: this.state.newCategoryId,
            })
          }
          Track.track('dashboard:categories_deleted', { id: this.props.category.id })
          this.props.onClose()
        })
    }
  }

  render() {
    const { category } = this.props
    const categories = this.props.currentCompanyStore!.productStore!.categories || []
    const mergeableCategories = categories.filter(
      (c) => c.id !== category.id && c.id !== category.parentCategoryId,
    )

    return (
      <Modal isOpen={true} toggle={() => this.props.onClose()}>
        <ModalHeader toggle={() => this.props.onClose()}>Delete category</ModalHeader>
        <ModalBody>
          <div className='d-flex'>
            <div className='fa fa-exclamation-triangle text-muted fa-4x mr-3 mt-4' />
            <div>
              <div>You are about to delete the {category.name} category.</div>
              <small className='text-muted'>
                <div>Please select a category to migrate all existing products to</div>
              </small>
              <br />
              <div>
                <Select
                  value={this.state.newCategoryId}
                  clearable={true}
                  options={mergeableCategories.map((c) => {
                    return {
                      label: c.name,
                      value: c.id,
                    }
                  })}
                  onChange={(option: { label: string; value: string }) => {
                    this.setState({
                      newCategoryId: option ? option.value : undefined,
                    })
                  }}
                />
              </div>
            </div>
          </div>

          <br />

          <div>
            <button
              className='btn btn-large btn-danger w-100'
              disabled={this.state.isSaving}
              onClick={() => this.deleteCategory()}
            >
              {this.state.isSaving ? 'Deleting...' : 'Delete'}
            </button>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}
